/* Braymont reviews: lightweight Load More with no network calls. */
(() => {
  function initReviews(root) {
    if (root.dataset.bmInit === 'true') return;
    root.dataset.bmInit = 'true';
    const reviews = [...root.querySelectorAll('[data-bm-review]')];
    const button = root.querySelector('[data-bm-load-more]');
    const counter = root.querySelector('[data-bm-review-count]');
    const starting = Math.max(1, Number.parseInt(root.dataset.start || '6', 10) || 6);
    const step = Math.max(1, Number.parseInt(root.dataset.step || '6', 10) || 6);
    let visible = Math.min(starting, reviews.length);
    const paint = () => {
      reviews.forEach((review,i) => {review.hidden = i >= visible;});
      if (counter) counter.textContent = 'Showing ' + visible + ' of ' + reviews.length + ' entries';
      if (button) button.hidden = visible >= reviews.length;
    };
    if (button) button.addEventListener('click',() => {visible = Math.min(reviews.length,visible+step);paint();});

    /* One native modal per reviews section, reused for every photo. */
    const lightbox = root.querySelector('[data-bm-review-lightbox]');
    const largeImage = lightbox?.querySelector('[data-bm-lightbox-image]');
    const closeButton = lightbox?.querySelector('[data-bm-lightbox-close]');
    if (lightbox && largeImage) {
      root.addEventListener('click', event => {
        const trigger = event.target.closest('[data-bm-review-photo]');
        if (!trigger || !root.contains(trigger)) return;
        const src = trigger.getAttribute('data-bm-photo-src');
        if (!src) return;
        largeImage.src = src;
        largeImage.alt = trigger.getAttribute('data-bm-photo-alt') || 'Expanded customer review photograph';
        lightbox.showModal();
      });
      closeButton?.addEventListener('click', () => lightbox.close());
      lightbox.addEventListener('click', event => {
        if (event.target === lightbox) lightbox.close();
      });
      lightbox.addEventListener('close', () => {
        largeImage.removeAttribute('src');
      });
    }
    paint();
  }
  function init(){document.querySelectorAll('[data-bm-reviews]').forEach(initReviews);}
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();
